import { Turbo } from '@hotwired/turbo-rails';
import { isDevelopment } from './utils/dev';
if (window.__fw_app__.tvSession) {
    document.addEventListener('wlaRemoteKeyEvent', (event) => {
        const { detail } = event;
        if (detail.action !== 'ACTION_DOWN')
            return;
        const activeElement = document.activeElement;
        if (!activeElement) {
            return focusFirstElement();
        }
        if (activeElement instanceof HTMLElement && !activeElement.dataset.tvFocusable) {
            return focusFirstElement();
        }
        if (detail.key === 'KEYCODE_DPAD_RIGHT') {
            focusNextFocusable();
        }
        if (detail.key === 'KEYCODE_DPAD_LEFT') {
            focusPreviousFocusable();
        }
        if (detail.key === 'KEYCODE_DPAD_UP') {
            const activeElement = document.activeElement;
            if (!activeElement)
                return;
            const closestFocusContainer = activeElement.closest('[data-tv-focus-container]');
            if (!(closestFocusContainer instanceof HTMLElement))
                return;
            if (closestFocusContainer.dataset.tvFocusContainerGrid) {
                focusPrevoiusGridRow();
            }
            else {
                focusPreviousContainer();
            }
        }
        if (detail.key === 'KEYCODE_DPAD_DOWN') {
            const activeElement = document.activeElement;
            if (!activeElement)
                return;
            const closestFocusContainer = activeElement.closest('[data-tv-focus-container]');
            if (!(closestFocusContainer instanceof HTMLElement))
                return;
            if (closestFocusContainer.dataset.tvFocusContainerGrid) {
                focusNextGridRow();
            }
            else {
                focusNextContainer();
            }
        }
        if (detail.key === 'KEYCODE_DPAD_CENTER') {
            const activeElement = document.activeElement;
            if (!(activeElement instanceof HTMLElement))
                return;
            if (activeElement instanceof HTMLInputElement) {
                document.dispatchEvent(new CustomEvent('wlaTvKeyboardOpen'));
            }
            else {
                activeElement.click();
            }
        }
        if (detail.key === 'KEYCODE_BACK') {
            const activeElement = document.activeElement;
            const activeNavLink = document.querySelector('[data-tv-focusable].active');
            if (!(activeElement instanceof HTMLElement))
                return;
            if (!activeNavLink && Turbo.navigator.history.currentIndex > 0) {
                return window.history.back();
            }
            if (!activeNavLink && Turbo.navigator.history.currentIndex === 0) {
                return document.dispatchEvent(new CustomEvent('wlaTvBack'));
            }
            if (location.pathname.match(new RegExp(/\/supporters\/tv\/series\/\d+/)) &&
                Turbo.navigator.history.currentIndex > 0) {
                return window.history.back();
            }
            if (activeElement !== activeNavLink) {
                return activeNavLink?.focus();
            }
            if (activeNavLink.attributes.getNamedItem('href')?.value === '/supporters/tv/home') {
                return document.dispatchEvent(new CustomEvent('wlaTvBack'));
            }
            Turbo.visit('/supporters/tv/home');
        }
    });
    if (isDevelopment()) {
        document.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowRight' ||
                event.key === 'ArrowLeft' ||
                event.key === 'ArrowUp' ||
                event.key === 'ArrowDown' ||
                event.key === 'Enter' ||
                event.key === 'Backspace') {
                event.preventDefault();
            }
            if (event.key === 'ArrowRight') {
                document.dispatchEvent(new CustomEvent('wlaRemoteKeyEvent', {
                    detail: {
                        key: 'KEYCODE_DPAD_RIGHT',
                        action: 'ACTION_DOWN',
                    },
                }));
            }
            if (event.key === 'ArrowLeft') {
                document.dispatchEvent(new CustomEvent('wlaRemoteKeyEvent', {
                    detail: {
                        key: 'KEYCODE_DPAD_LEFT',
                        action: 'ACTION_DOWN',
                    },
                }));
            }
            if (event.key === 'ArrowUp') {
                document.dispatchEvent(new CustomEvent('wlaRemoteKeyEvent', {
                    detail: {
                        key: 'KEYCODE_DPAD_UP',
                        action: 'ACTION_DOWN',
                    },
                }));
            }
            if (event.key === 'ArrowDown') {
                document.dispatchEvent(new CustomEvent('wlaRemoteKeyEvent', {
                    detail: {
                        key: 'KEYCODE_DPAD_DOWN',
                        action: 'ACTION_DOWN',
                    },
                }));
            }
            if (event.key === 'Enter') {
                document.dispatchEvent(new CustomEvent('wlaRemoteKeyEvent', {
                    detail: {
                        key: 'KEYCODE_DPAD_CENTER',
                        action: 'ACTION_DOWN',
                    },
                }));
            }
            if (event.key === 'Backspace') {
                document.dispatchEvent(new CustomEvent('wlaRemoteKeyEvent', {
                    detail: {
                        key: 'KEYCODE_BACK',
                        action: 'ACTION_DOWN',
                    },
                }));
            }
        });
    }
    const focusPreviousFocusable = () => {
        const activeElement = document.activeElement;
        if (!activeElement)
            return;
        if (!(activeElement instanceof HTMLElement))
            return;
        const closestFocusContainer = activeElement.closest('[data-tv-focus-container]');
        if (!closestFocusContainer)
            return;
        const allFocusablesInClosestFocusContainer = closestFocusContainer.querySelectorAll('[data-tv-focusable]');
        const currentFocusableIndex = Array.from(allFocusablesInClosestFocusContainer).indexOf(activeElement);
        const previousFocusable = allFocusablesInClosestFocusContainer[currentFocusableIndex - 1];
        if (previousFocusable && previousFocusable instanceof HTMLElement) {
            previousFocusable.focus();
        }
    };
    const focusNextFocusable = () => {
        const activeElement = document.activeElement;
        if (!activeElement)
            return;
        if (!(activeElement instanceof HTMLElement))
            return;
        const closestFocusContainer = activeElement.closest('[data-tv-focus-container]');
        if (!closestFocusContainer)
            return;
        const allFocusablesInClosestFocusContainer = closestFocusContainer.querySelectorAll('[data-tv-focusable]');
        const currentFocusableIndex = Array.from(allFocusablesInClosestFocusContainer).indexOf(activeElement);
        const nextFocusable = allFocusablesInClosestFocusContainer[currentFocusableIndex + 1];
        if (nextFocusable && nextFocusable instanceof HTMLElement) {
            nextFocusable.focus();
        }
    };
    const focusPreviousContainer = () => {
        const activeElement = document.activeElement;
        if (!activeElement)
            return;
        const closestFocusContainer = activeElement.closest('[data-tv-focus-container]');
        if (!closestFocusContainer)
            return;
        const allFocusContainers = document.querySelectorAll('[data-tv-focus-container]');
        const currentFocusContainerIndex = Array.from(allFocusContainers).indexOf(closestFocusContainer);
        const previousFocusContainer = allFocusContainers[currentFocusContainerIndex - 1];
        if (!(previousFocusContainer instanceof HTMLElement))
            return;
        // Focus first focusable element or first active element (active navigation link)
        previousFocusContainer.querySelector('[data-tv-focusable]')?.focus();
        previousFocusContainer.querySelector('[data-tv-focusable].active')?.focus();
    };
    const focusNextContainer = () => {
        const activeElement = document.activeElement;
        if (!activeElement)
            return;
        const closestFocusContainer = activeElement.closest('[data-tv-focus-container]');
        if (!closestFocusContainer)
            return;
        const allFocusContainers = document.querySelectorAll('[data-tv-focus-container]');
        const currentFocusContainerIndex = Array.from(allFocusContainers).indexOf(closestFocusContainer);
        const nextFocusContainer = allFocusContainers[currentFocusContainerIndex + 1];
        if (!(nextFocusContainer instanceof HTMLElement))
            return;
        if (allFocusContainers[currentFocusContainerIndex + 2]?.classList.contains('hidden')) {
            allFocusContainers[currentFocusContainerIndex + 2]?.classList.remove('hidden');
        }
        nextFocusContainer.querySelector('[data-tv-focusable]')?.focus();
    };
    const focusPrevoiusGridRow = () => {
        const activeElement = document.activeElement;
        if (!activeElement)
            return;
        const closestFocusContainer = activeElement.closest('[data-tv-focus-container]');
        if (!(closestFocusContainer instanceof HTMLElement))
            return;
        const allFocusables = closestFocusContainer.querySelectorAll('[data-tv-focusable]');
        const currentFocusableIndex = Array.from(allFocusables).indexOf(activeElement);
        const gridColumns = closestFocusContainer.dataset.tvFocusContainerGridColumns;
        if (!gridColumns)
            return;
        if (currentFocusableIndex < parseInt(gridColumns))
            return focusPreviousContainer();
        const newFocusElement = allFocusables[currentFocusableIndex - parseInt(gridColumns)];
        if (!(newFocusElement instanceof HTMLElement))
            return;
        newFocusElement.focus();
    };
    const focusNextGridRow = () => {
        const activeElement = document.activeElement;
        if (!activeElement)
            return;
        const closestFocusContainer = activeElement.closest('[data-tv-focus-container]');
        if (!(closestFocusContainer instanceof HTMLElement))
            return;
        const allFocusables = closestFocusContainer.querySelectorAll('[data-tv-focusable]');
        const currentFocusableIndex = Array.from(allFocusables).indexOf(activeElement);
        const gridColumns = closestFocusContainer.dataset.tvFocusContainerGridColumns;
        if (!gridColumns)
            return;
        const newFocusElement = allFocusables[currentFocusableIndex + parseInt(gridColumns)];
        if (!(newFocusElement instanceof HTMLElement))
            return;
        newFocusElement.focus();
    };
    const focusFirstElement = () => {
        document.querySelector('[data-tv-focusable]')?.focus();
        document.querySelector('[data-tv-focusable].active')?.focus();
        document.querySelector('[data-tv-focus-on-turbo-load="true"]')?.focus();
    };
    document.addEventListener('turbo:load', () => {
        const activeElement = document.activeElement;
        if (activeElement !== document.body)
            return;
        focusFirstElement();
        document.dispatchEvent(new CustomEvent('wlaTvPageLoaded'));
    });
    document.addEventListener('turbo:frame-load', (e) => {
        document.querySelector('.video.video--tv[data-tv-focusable]')?.focus();
    });
}
